//Bestimmt groupId ohne Berücksichtigung von Alter und Geschlecht
//
export function simpleGroupId(pSum, targetCount, steps = 1) {
  const sum = sumArray(pSum);
  function sumArray(serverData) {

    const sum = [];
    serverData.forEach(d => sum[d.group_id - 1] = convertAttrToNumbers(d));
    for (let i = 0; i < 4; i++) {
      if (!sum[i]) {
        sum[i] = {group_id: i + 1, n: 0, male: 0, age: 0}
      }
    }
    return sum;
  }

  function convertAttrToNumbers(o) {
    Object.keys(o).forEach(key => o[key] = +o[key]);
    return o;
  }


  function calcManko(actual, target, steps) {
    const stepSize = targetCount.map(n=>n/steps);
    const manko = actual.map((s,ind)=>targetCount[ind]-s);
    const stepManko = manko.map((m,ind)=> m==0 ? 0: m/stepSize[ind]);
    const targetStep=Math.ceil(Math.max(...stepManko))-1;
    return stepManko.map(t=>Math.max(t-targetStep,0))
  }

  function normArray(a) {
    const sum = a.reduce((acc, cur) => acc + cur, 0);
    return a.map(v => v / sum);
  }

  function randomWeightedGroupId(a) {
    const aNorm = normArray(a);
    const rnd = Math.random();
    let sum = 0;
    let index = 0;
    while (rnd >= sum) {
      sum += aNorm[index];
      index++;
    }
    return index;
  }

//Beginn Funktion ****************************************
  const probs = calcManko(sum.map(s => s.n), targetCount, steps);
  console.log(probs);
  return randomWeightedGroupId(probs);
}